<header
  role="banner"
  class="sticky top-0 left-0 right-0 border-b border-gray-300 z-50 h-14 p-4 lg:h-[70px] lg:pr-6 lg:pl-9"
  [style.backgroundColor]="bgBase()"
>
  <div class="container mx-auto flex items-center justify-between h-full">
    <div class="flex flex-nowrap items-center gap-7.5">
      <figure>
        <a routerLink="/">
          <img
            [src]="logoPath()"
            [alt]="logoAlt()"
            class="h-auto max-h-[21px] w-auto cursor-pointer"
          />
        </a>
      </figure>

      <ul class="hidden flex-nowrap gap-2 lg:flex">
        @for (item of menuItems; track item.name) { @if (!item.onlyMobile) {
        <li class="px-4 py-3">
          <a
            #rla="routerLinkActive"
            [routerLink]="navbarService.getLocalizedUrl(item.url)"
            [routerLinkActiveOptions]="{ exact: item.exact }"
            routerLinkActive="font-regular"
            [fragment]="item.fragment"
            class="cursor-pointer"
            [ngStyle]="{
              color: navbarService.isLinkActiveWithFragment(item)
                ? primary()
                : '',
              fontWeight: navbarService.isLinkActiveWithFragment(item)
                ? '500'
                : ''
            }"
          >
            {{ item.name | translate }}</a
          >
        </li>
        } }
      </ul>
    </div>

    <div class="flex items-center gap-4 lg:gap-8">
      <div class="relative">
        <neopos-lang-selector
          class="absolute right-0 -top-[13px] lg:-top-[19px]"
        />
      </div>

      <a
        [routerLink]="navbarService.getLocalizedUrl('routes.cart')"
        [attr.aria-label]="'Koszyk' | translate"
        class="flex items-center gap-2"
      >
        <span class="relative">
          <neopos-icon name="cart" class="text-2xl" />

          @if (activeCart().totalItems; as count){
          <span
            class="absolute flex justify-center items-center rounded-full w-[14px] h-[14px] text-[7px] font-semibold text-center text-white bottom-0 right-0"
            [style.backgroundColor]="primary()"
            >{{ count }}</span
          >}
        </span>

        <span class="hidden lg:inline">{{ 'Koszyk' | translate }}</span>
      </a>

      <a
        [routerLink]="navbarService.getLocalizedUrl('routes.account')"
        class="flex items-center gap-2"
      >
        <neopos-icon name="profile" class="text-2xl" />

        <span class="hidden lg:inline">{{ 'Moje konto' | translate }}</span>
      </a>

      <neopos-icon-button
        name="menu"
        (click)="menuOpened.set(true)"
        className="text-2xl"
        class="lg:!hidden"
        [ariaLabel]="'Pokaż menu' | translate"
      />
    </div>
  </div>
</header>

@if (menuOpened()) {
<neopos-mobile-menu
  [menuItems]="menuItems"
  (menuItemClick)="menuOpened.set(false)"
/>
}
